import { Box } from '@mui/material';
import {
  CustomAutoComplete,
  CustomButton,
  CustomTextField,
  DrawerFormActionSummary,
  DrawerFormSection,
  InfoTooltip,
  renderTwoLineOption,
} from '../../../common/components';
import { AUTOCOMPLETE_LISTBOX_PROPS, drawerFieldSpan } from '../../../common/styles';
import { toProviderOptions } from '../../utils/toProviderOptions';
import { CONSOLIDATED_SUPPLY_TEXTS as TEXTS } from '../constants/consolidatedSupplyTexts';

/** Datos compartidos por los borradores y alcance real de la selección. */
const ConsolidatedSupplyProviderFields = ({
  providers,
  provider,
  commitment,
  onProvider,
  onCommitment,
  disabled,
  selectedCount,
  includedCount,
  excludedCount,
  onReviewExcluded,
  onNext,
}) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
    <DrawerFormSection
      title={TEXTS.purchase}
      action={<InfoTooltip lines={[TEXTS.documentHint]} />}
    >
      <CustomAutoComplete
        label={TEXTS.provider}
        options={toProviderOptions(providers)}
        value={provider}
        renderOption={renderTwoLineOption}
        inputPlaceholder={TEXTS.providerSearch}
        ListboxProps={AUTOCOMPLETE_LISTBOX_PROPS}
        disabled={disabled}
        sx={drawerFieldSpan(8)}
        onChange={(event) => onProvider(event.target.value)}
      />
      <CustomTextField
        label={TEXTS.commitment}
        type="date"
        value={commitment}
        shrinkLabel
        sx={drawerFieldSpan(4)}
        disabled={disabled}
        onChange={(event) => onCommitment(event.target.value)}
      />
    </DrawerFormSection>
    <DrawerFormSection title={TEXTS.order}>
      {[
        [TEXTS.selectedOrders, selectedCount],
        [TEXTS.includedOrders, includedCount],
        [TEXTS.excludedOrders, excludedCount],
      ].map(([label, value]) => (
        <DrawerFormActionSummary
          key={label}
          label={label}
          value={String(value)}
          sx={drawerFieldSpan(4)}
        />
      ))}
      <Box sx={{ ...drawerFieldSpan(12), display: 'flex', gap: 1.25, flexWrap: 'wrap', mt: 1 }}>
        <CustomButton variant="outlined" onClick={onNext}>
          {TEXTS.next}
        </CustomButton>
        {excludedCount > 0 && (
          <CustomButton variant="text" onClick={onReviewExcluded}>
            {TEXTS.excludedCount(excludedCount)}
          </CustomButton>
        )}
      </Box>
    </DrawerFormSection>
  </Box>
);

export default ConsolidatedSupplyProviderFields;
